import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { putRequest } from '../../../requestUtils';
import climbingLadder from '../../../../assets/images/climbing-the-ladder.png';
import './ProposalQuestion.scss';

class ProposalQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.modalIsOpen,
      question: '',
      isProcessing: false,
    };

    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleClearDisplayMessage = this.handleClearDisplayMessage.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.modalIsOpen && !prevState.showModal) {
      return { showModal: true };
    }
    return null;
  }

  handleClearDisplayMessage() {
    setTimeout(() => {
      this.setState({
        errorMessage: '',
        succesMessage: '',
      });
    }, 6000);
  }

  handleHideModal() {
    const { showModalCallback } = this.props;
    if (showModalCallback) {
      showModalCallback();
    }
    this.setState({ showModal: false });
  }

  handleShowModal() {
    const { showModalCallback } = this.props;
    if (showModalCallback) {
      showModalCallback();
    }
    this.setState({ showModal: true });
  }

  handleOnChange(value) {
    this.setState({ question: value });
  }

  handleSubmit() {
    const { url, csrfToken } = this.props;
    const { question } = this.state;

    this.setState({ isProcessing: true });
    putRequest(url, { question }, csrfToken)
      .then(({ data }) => {
        this.setState({
          isProcessing: false,
          question: '',
          succesMessage: data.message,
        });
        this.handleClearDisplayMessage();
      }).catch(({ message }) => {
        this.setState({
          isProcessing: false,
          errorMessage: message,
        });
        this.handleClearDisplayMessage();
      });
  }

  render() {
    const {
      showModal,
      succesMessage,
      errorMessage,
      question,
      isProcessing,
    } = this.state;
    const disableSendQuestionBtn = question === '';
    return (
      <Fragment>
        <div className="proposal-question">
          <div className="header">
            Questions about this candidate?
          </div>
          <div className="body-content">
            <img src={climbingLadder} alt="climbing ladder" />
            <div className="question-info">
              We’re here to help! If we don’t know the answer, we can contact Olga to find out.
            </div>
          </div>
          <Button
            className="btn-ask-question"
            onClick={this.handleShowModal}
          >
            Ask us a Question
          </Button>
        </div>
        <Modal
          show={showModal}
          onHide={this.handleHideModal}
          dialogClassName="proposal-question-modal"
          size="lg"
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <div className="header">
              Ask a question about this candidate / proposal
            </div>
            <div className="body-text">
              What questions do you have about this candidate or proposal?
              We’ll contact you soon with a response.
              <strong> Only Clora will see your question/comments.</strong>
            </div>
            <textarea
              className="proposal-question-textarea"
              rows="3"
              placeholder="Type your question here..."
              value={question}
              onChange={(event) => this.handleOnChange(event.target.value)}
            />
            {succesMessage && <div className="success-message">{succesMessage}</div>}
            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={`${disableSendQuestionBtn ? 'btn btn-disabled' : 'btn-send-question'}`}
              onClick={this.handleSubmit}
            >
              Send question
              {isProcessing ? '...' : ''}
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

ProposalQuestion.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool,
  showModalCallback: PropTypes.func,
};

ProposalQuestion.defaultProps = {
  modalIsOpen: false,
  showModalCallback: () => {},
};

export default ProposalQuestion;
